import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

//ADMIN
import admin_revisiones from '@/views/admin/revisiones'

import admin_solicitudes from '@/views/admin/solicitudes'
import admin_estadisticas from '@/views/admin/estadisticas'
import admin_alumnos from '@/views/admin/alumnos'
import admin_exportadores from '@/views/admin/Exportadores'
import comentarios_di from '@/views/admin/ComentariosDI'

import alumno_detalle from '@/views/alumno/Perfil/PerfilScreen'

//USER
import user_dashboard from '@/views/alumno/Practicas/PracticasScreen'
import user_curriculum from '@/views/alumno/Curriculum/CurriculumScreen'
import welcome from '@/views/alumno/Tutorial/Tutorial'

import empresas from '@/views/empresa/EmpresasScreen'
import empresa_detalle from '@/views/alumno/empresa/EmpresaDetail'
import admin_empresa_detalle from '@/views/admin/empresa/EmpresaDetailAdmin'


import home from '@/views/Home'
import practica_revisar from '@/views/admin/practica_en_revision'
import admin_logs from '@/views/admin/Logs'

import evaluador_confirmar from '@/views/evaluador/confirmar_practica'
import evaluador_evaluar from '@/views/evaluador/evaluar_practica'

import error from '@/views/info/error'
import success from '@/views/info/success'

import new_practica from '@/views/alumno/Practicas/NuevaPractica'
import finish from '@/views/alumno/Practicas/FinalizarPractica'
import noticias from '@/views/alumno/Noticias/noticias'
import preguntas from '@/views/alumno/Preguntas/preguntas'
import info_proceso from '@/views/alumno/InfoProceso/info_proceso'



Vue.use(VueRouter);

// Los guards leen el usuario que confirmó el backend al iniciar sesión (store),
// no el de localStorage: ese se puede editar desde el navegador.
function usuario() {
  const { status, user } = store.state.authentication;
  return status.loggedIn ? user : null;
}

function auth_admin(to, from, next) {
  const user = usuario();
  if (user && user.is_staff) {
    next()
  } else {
    next('/');
  }
}

// Función que verifica si un usuario no sea staff y además haya completado el tutorial -> inicia sesión
function auth_user(to, from, next) {
  const user = usuario();
  if (!user || user.is_staff) {
    next('/');
  } else if (user.tutorial_complete) {
    next()
  } else {
    next('/welcome')
  }
}

// Función que verifica si un usuario no sea staff y además no haya completado el tutorial -> lo manda al tutorial
function auth_user_welcome(to, from, next) {
  const user = usuario();
  if (!user || user.is_staff) {
    next('/');
  } else if (user.tutorial_complete) {
    next('/user_dashboard')
  } else {
    next()
  }
}

function auth(to, from, next) {
  if (usuario()) {
    next()
  } else {
    next('/');
  }
}

const routes = [

  //ADMIN ROUTES


  {
    path: '/alumnos',
    name: 'Alumnos',
    component: admin_alumnos,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/alumno/:username',
    name: 'Detalle Alumno',
    component: alumno_detalle,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/practica/:token',
    name: 'Revisar Práctica',
    component: practica_revisar,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/logs',
    name: 'Logs',
    component: admin_logs,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/admin_empresas',
    name: 'Empresas',
    component: empresas,
    props: { admin: true },
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/admin_empresas/:id',
    name: 'Detalle de Empresa',
    component: admin_empresa_detalle,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/admin_revisiones',
    name: 'En revisión',
    component: admin_revisiones,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/admin_solicitudes',
    name: 'Solicitudes Pendientes',
    component: admin_solicitudes,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },
 
  {
    path: '/comentarios_di',
    name: 'Comentarios DI',
    component: comentarios_di,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },
  
  {
    // Se carga con import() y no con un import de arriba a proposito: el editor
    // de texto (Tiptap) pesa 121 KB comprimidos y solo lo usa un administrador.
    // Con la carga diferida ese peso va a su propio chunk y no lo descarga
    // quien solo abre la pantalla de inicio.
    path: '/configuracion',
    name: 'Configuración',
    component: () => import(/* webpackChunkName: "configuracion" */ '@/views/admin/Configuracion/ConfiguracionScreen'),
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    // Mismo webpackChunkName que la vista anterior: las dos viajan juntas y es
    // la que arrastra el editor de texto.
    path: '/configuracion/info_proceso',
    // El nombre NO puede repetir el de la ruta publica /info_proceso: noticias.vue
    // navega con push({ name: "Información del Proceso" }) y con dos rutas
    // homonimas vue-router resuelve por la ultima registrada, asi que el alumno
    // podria acabar rebotando contra el guard de administrador.
    name: 'Configuración del proceso',
    component: () => import(/* webpackChunkName: "configuracion" */ '@/views/admin/Configuracion/InfoProcesoEditor'),
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    // Mismo chunk y mismo cuidado con el nombre que la anterior: la ruta publica
    // /preguntas_frecuentes ya se llama 'Preguntas Frecuentes'.
    path: '/configuracion/preguntas_frecuentes',
    name: 'Configuración de preguntas frecuentes',
    component: () => import(/* webpackChunkName: "configuracion" */ '@/views/admin/Configuracion/PreguntasFrecuentesEditor'),
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/configuracion/representantes',
    name: 'Configuración de representantes',
    component: () => import(/* webpackChunkName: "configuracion" */ '@/views/admin/Configuracion/RepresentantesEditor'),
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/configuracion/modos',
    name: 'Configuración de modos de práctica',
    component: () => import(/* webpackChunkName: "configuracion" */ '@/views/admin/Configuracion/ModosEditor'),
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },

  {
    path: '/exportadores',
    name: 'Exportadores',
    component: admin_exportadores,
    beforeEnter: (to, from, next) => {
      auth_admin(to, from, next)
    }
  },


  {
    path: '/estadisticas',
    name: 'Estadísticas',
    component: admin_estadisticas,
    beforeEnter: (to, from, next) => {
      auth(to, from, next)
    }
  },


 //BOTH ROUTES
  {
    path: '/empresas',
    name: 'Lista de Empresas',
    component: empresas,
    beforeEnter: (to, from, next) => {
      auth(to, from, next)
    }
  },

  {
    path: '/preguntas_frecuentes',
    name: 'Preguntas Frecuentes',
    component: preguntas,
  },

  {
    path: '/info_proceso',
    name: 'Información del Proceso',
    component: info_proceso,
  },

  //USER ROUTES

  {
    path: '/welcome',
    name: 'Te damos la bienvenida al Sístema de Práctica',
    component: welcome,
    beforeEnter: (to, from, next) => {
      auth_user_welcome(to, from, next)
    }
  },

  {
    path: '/user_dashboard',
    name: 'Mis Prácticas',
    component: user_dashboard,
    beforeEnter: (to, from, next) => {
      auth_user(to, from, next)
    }
  },


  {
    path: '/perfil',
    name: 'Mi perfil',
    props: true,
    component: user_curriculum,
    beforeEnter: (to, from, next) => {
      auth_user(to, from, next)
    }
  },

  {
    path: '/new_practica',
    name: 'Inscribir Práctica',
    component: new_practica,
    beforeEnter: (to, from, next) => {
      auth_user(to, from, next)
    }
  },

  {
    path: '/informaciones',
    name: 'Informaciones',
    component: noticias,
    beforeEnter: (to, from, next) => {
      auth_user(to, from, next)
    }
  },

  {
    path: '/empresas/:id',
    name: 'Detalle Empresa',
    component: empresa_detalle,
    beforeEnter: (to, from, next) => {
      auth(to, from, next)
    }
  },


  
  {
    path: '/',
    name: 'Iniciar Sesión',
    component: home,
    beforeEnter: (to, from, next) => {
      const user = usuario();
      if (!user) {
        next()
      } else if (user.is_staff) {
        next('/admin_revisiones');
      } else {
        next('/user_dashboard');
      }
    }
  },
  {
    path: '/confirmar-practica/:token',
    component: evaluador_confirmar,
  },
  {
    path: '/evaluar-practica/:token',
    component: evaluador_evaluar,
  },
  {
    path: '/error',
    component: error,
  },
  {
    path: '/success',
    component: success,
  },
  {
    name: 'Finalizar Práctica',
    path: '/finalizar_practica/:token',
    component: finish,
    beforeEnter: (to, from, next) => {
      auth_user(to, from, next)
    }
  }
]

const router = new VueRouter({
  routes
})


export default router
